import { store } from "../../store/store";
import { setFreezeUI } from "../../store/slices/session.slice";

// Таймер відкладеного unfreeze — скасовується новим freeze, щоб
// unfreeze попередньої задачі не зняв freeze наступної
let unfreezeTimer: ReturnType<typeof setTimeout> | null = null;

const clearUnfreezeTimer = () => {
	if (unfreezeTimer !== null) {
		clearTimeout(unfreezeTimer);
		unfreezeTimer = null;
	}
};

const uiService = {
	handleFreeze() {
		clearUnfreezeTimer();
		store.dispatch(setFreezeUI(true));
	},
	handleUnfreeze() {
		// Задержка ля завершения всех анимаций
		clearUnfreezeTimer();
		unfreezeTimer = setTimeout(() => {
			unfreezeTimer = null;
			store.dispatch(setFreezeUI(false));
		}, 400);
	},
};
export default uiService;
